
import React from 'react';
import { Event } from '@/lib/types';
import EventsTableRow from './EventsTableRow';

interface EventsTableProps {
  events: Event[];
  onViewEvent: (event: Event) => void;
  onEditEvent: (event: Event) => void;
  onDeleteEvent: (event: Event) => void;
}

const EventsTable = ({ events, onViewEvent, onEditEvent, onDeleteEvent }: EventsTableProps) => {
  return (
    <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
      <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            <th scope="col" className="px-6 py-3">
              Név
            </th>
            <th scope="col" className="px-6 py-3">
              Leírás
            </th>
            <th scope="col" className="px-6 py-3">
              Dátum
            </th>
            <th scope="col" className="px-6 py-3">
              Helyszín
            </th>
            <th scope="col" className="px-6 py-3">
              Típus
            </th>
            <th scope="col" className="px-6 py-3">
              Státusz
            </th>
            <th scope="col" className="px-6 py-3">
              Műveletek
            </th>
          </tr>
        </thead>
        <tbody>
          {events.map((event) => (
            <EventsTableRow
              key={event.id}
              event={event}
              onView={onViewEvent}
              onEdit={onEditEvent}
              onDelete={onDeleteEvent}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EventsTable;
